import { PAYMODE } from '../../../common/src/constant';
import { getKey } from '../../../common/src/utils/common';
import { globaleStore } from '../common/cache';
import { log } from '../common/logger';
import {
  calculateAmountPayable,
  clientMessage,
  cloneObject,
  defaultSelected,
  equalsIgnoreCase,
  isAddNPay,
  loggedInChanged
} from '../utils/common';
import CONSTANT, { CACHE, RESPONSE_STATUS, GLOBAL_STORE } from '../utils/constants';
import { locale } from '../utils/i18n';

export function updateOnNewFPO(response, cache, checkoutElementPayMode, subscription, methods) {
  const { onSelectChange, onLoginDataChange, onBtnTextChange } = methods || {};
  const payOptions = loggedInChanged(response, cache, checkoutElementPayMode);
  const selected = defaultSelected(payOptions.cashierData, cache);
  // if (selected) {
  //   scrollToSelectedOption(selected);
  // }
  onSelectChange && onSelectChange(selected);
  onLoginDataChange && onLoginDataChange(payOptions.cashierData);
  if (equalsIgnoreCase(getKey(selected, 'type'), PAYMODE.LOGIN)) {
    /*
     * if selected component is login then change btn text to proceed instead of pay
     * */
    const locale = clientMessage(CONSTANT.LOGIN.toLowerCase(), cache);
    onBtnTextChange && onBtnTextChange(locale.label.btnSendOtpText);
  } else {
    const txnAmount = cache.getData(CONSTANT.TXN_AMOUNT);
    const amountPayable = calculateAmountPayable(
      txnAmount,
      payOptions.cashierData.wallet,
      true,
      subscription
    );

    let btnText = locale('payButton.text') + amountPayable;
    if (
      isAddNPay(payOptions.cashierData, cache) &&
      !equalsIgnoreCase(getKey(selected, 'type'), CONSTANT.MGV)
    ) {
      const { addNPayText } = locale('payButton.text');
      btnText = addNPayText.replace('amount', amountPayable);
    }
    onBtnTextChange && onBtnTextChange(btnText);
  }
}

export function logoutUser(cache, checkoutElementPayMode, subscription, methods) {
  return new Promise((resolve, reject) => {
    cache
      .getData(CACHE.API)
      .logout()
      .then(res => {
        res = res.body;
        if (res && getKey(res, 'resultInfo')) {
          if (
            getKey(res, 'txnInfo.RESPCODE', '') === '1006' ||
            getKey(res, 'resultInfo.resultCode', '') === '1006'
          ) {
            const mConfig = cache.getData(CACHE.MERCHANT_CONFIG);
            cache.getData(CACHE.STORE).setState({ sessionExpired: true });
            const notifyMerchant = getKey(mConfig, 'handler.notifyMerchant', undefined);
            if (notifyMerchant && notifyMerchant.constructor === Function) {
              notifyMerchant(CONSTANT.NOTIFY_MERCHANT_EVENTS.SESSION_EXPIRED, res);
            }
          }
          const resultCode = getKey(res, 'resultInfo.resultStatus', '');
          const isSuccess =
            equalsIgnoreCase(resultCode, RESPONSE_STATUS.S) ||
            equalsIgnoreCase(resultCode, RESPONSE_STATUS.SUCCESS);
          if (isSuccess) {
            log({
              eventType: 'Checkout_Logout',
              logOutSuccess: true
            });
            if (checkoutElementPayMode) {
              const clonedResponse = cloneObject(res);
              globaleStore.setState({ [GLOBAL_STORE.FPO_UPDATED_RESPONSE]: clonedResponse });
            } else {
              updateOnNewFPO(res, cache, checkoutElementPayMode, subscription, methods);
            }
            resolve({ response: res, isSuccess });
          } else {
            const errorMsg = getKey(res, 'resultInfo.resultMsg', CONSTANT.GENERIC_ERROR);
            log({
              eventType: 'Checkout_Logout',
              logOutSuccess: false,
              errorMsg
            });
            reject(res);
          }
        }
      })
      .catch(err => {
        const errorMsg = getKey(err, 'body.resultInfo.resultMsg', CONSTANT.GENERIC_ERROR);
        log({
          eventType: 'Checkout_Logout',
          logOutSuccess: false,
          errorMsg
        });
        reject(err);
      });
  });
}



// WEBPACK FOOTER //
// ./controllers/switch-user.js